module.exports = __webpack_public_path__ + "static/media/contract-dashboar.ce2956b5.jpeg";